import { Rule } from "antd/es/form";

export const requiredRule: Rule = { required: true, message: "Enter a value" };
export const emailRule: Rule = {
  type: "email",
  message: "Enter a valid email address",
};
